// extracted by mini-css-extract-plugin
export var button = "_lj-2";
export var card = "_lj-0";
export var closeButtonContainer = "_lj-3";
export var iconContainer = "_lj-1";